import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaBookMedical, FaBuilding, FaCalculator, FaHome, FaListAlt, 
  FaSchool, FaGraduationCap, FaGlobe, FaBook, FaUniversity, 
  FaFlask, FaLaptopCode, FaChartLine, FaOilCan, FaUserGraduate, 
  FaRobot, FaProjectDiagram, FaBars, FaTimes,
  FaMoneyBillAlt,
  FaMoneyCheckAlt,
  FaMoneyCheck,
  FaMoneyBillWave,
  FaRockrms,
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import logo from '../images/channelicon2.png';


const MyNavbar = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [activeCategory, setActiveCategory] = useState('competitive-exams');
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  // Inline styles object
  const styles = {
    // Main navbar styles
    navbarCustom: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      width: '100%',
      backgroundColor: '#000',
      borderBottom: '1px solid #e5e7eb',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      zIndex: 1000,
      height: '80px',
      display: 'flex',
      alignItems: 'center'
    },
    navbarContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 1rem',
      maxWidth: '100%',
      margin: '0 auto',
      width: '100%',
      height: '100%'
    },
    navbarBrand: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
      flexShrink: 0
    },
    logo: {
      height: '85px',
      width: 'auto',
      transition: 'transform 0.5s ease-in-out'
    },
    desktopNav: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      justifyContent: 'center',
      height: '100%'
    },
    navList: {
      display: 'flex',
      alignItems: 'center',
      listStyleType: 'none',
      margin: 0,
      padding: 0,
      height: '100%',
      justifyContent: 'center',
      flexWrap: 'nowrap'
    },
    navItem: {
      position: 'relative',
      height: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    navLink: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 12px',
      color: '#ffffffff',
      textDecoration: 'underline',
      fontWeight: '500',
      fontSize: '0.9rem',
      height: '100%',
      transition: 'color 0.3s',
      whiteSpace: 'nowrap',
      border: 'none',
      background: 'none',
      cursor: 'pointer'
    },
    navIcon: {
      marginRight: '6px',
      fontSize: '1rem',
      minWidth: '16px'
    },
    dropdownTrigger: {
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      color: '#343a40',
      fontWeight: '500',
      fontSize: '0.9rem',
      transition: 'color 0.3s',
      padding: '0 12px',
      textDecoration: 'none'
    },
    modernDropdown: {
      position: 'absolute',
      top: '100%',
      left: '50%',
      zIndex: 1001,
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      boxShadow: '0 10px 15px rgba(0,0,0,0.15)',
      minWidth: '800px',
      maxWidth: '900px',
      transform: 'translateX(-50%)',
      opacity: 1,
      visibility: 'visible',
      transition: 'opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease',
      transformOrigin: 'top center',
      overflow: 'hidden',
      border: '1px solid #e5e7eb',
      marginTop: 0
    },
    megamenuContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    categoriesSidebar: {
      width: '30%',
      backgroundColor: '#f8f9fa',
      padding: '15px 0',
      borderRadius: '8px 0 0 8px',
      maxHeight: '500px',
      overflowY: 'auto'
    },

    categoryItem: {
      display: 'flex',
      padding: '12px 15px',
      cursor: 'pointer',
      transition: 'all 0.3s',
      borderLeft: '4px solid transparent'
    },
    categoryItemActive: {
      backgroundColor: '#fff',
      borderLeft: '4px solid #58A950',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)'
    },
    categoryIcon: {
      fontSize: '1.5rem',
      color: '#58A950',
      marginRight: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    categoryInfo: {
      flex: 1
    },

    categoryTitle: {
      fontWeight: '600',
      fontSize: '0.95rem',
      marginBottom: '3px',
      color: '#343a40'
    },

    categoryDesc: {
      fontSize: '0.75rem',
      color: '#6c757d',
      marginTop: '0.25rem'
    },
    coursesContent: {
      width: '70%',
      padding: '20px',
      maxHeight: '500px',
      overflowY: 'auto'
    },
    coursesHeader: {
      fontSize: '1.1rem',
      fontWeight: '600',
      color: '#58A950',
      marginBottom: '15px',
      paddingBottom: '10px',
      borderBottom: '1px solid #e5e7eb'
    },
    coursesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '15px'
    },
    courseCard: {
      padding: '15px',
      backgroundColor: '#f8f9fa',
      borderRadius: '6px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s, box-shadow 0.3s',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textDecoration: 'none',
      position: 'relative',
      overflow: 'hidden'
    },
    courseIcon: {
      fontSize: '1.8rem',
      marginBottom: '10px',
      color: '#58A950'
    },
    courseTitle: {
      fontSize: '0.9rem',
      fontWeight: '500',
      color: '#343a40',
      textAlign: 'center'
    },
    mobileToggleBtn: {
      display: 'none',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'none',
      border: 'none',
      fontSize: '1.5rem',
      color: '#343a40',
      cursor: 'pointer',
      marginLeft: '1rem',
      flexShrink: 0
    },
    mobileSidebar: {
      position: 'fixed',
      top: 0,
      right: showOffcanvas ? '0' : '-280px',
      height: '100vh',
      width: '280px',
      backgroundColor: '#ffffff',
      boxShadow: '0 10px 15px rgba(0,0,0,0.15)',
      zIndex: 1002,
      transition: 'right 0.3s ease-in-out',
      overflowY: 'auto'
    },
    sidebarHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '20px',
      borderBottom: '1px solid #e5e7eb',
      backgroundColor: '#d1ecf1'
    },
    sidebarHeaderH3: {
      margin: 0,
      fontSize: '1.3rem',
      fontWeight: '600',
      color: '#343a40'
    },
    closeBtn: {
      background: 'none',
      border: 'none',
      fontSize: '1.5rem',
      color: '#343a40',
      cursor: 'pointer'
    },
    mobileNavList: {
      listStyleType: 'none',
      margin: 0,
      padding: '1rem 0'
    },
    mobileNavItem: {
      marginBottom: '0.125rem'
    },
    mobileNavLink: {
      display: 'flex',
      alignItems: 'center',
      padding: '0.75rem 1rem',
      color: '#343a40',
      textDecoration: 'none',
      fontWeight: '500',
      fontSize: '0.95rem',
      transition: 'all 0.3s ease-in-out'
    },
    mobileDropdownToggle: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      cursor: 'pointer',
      alignItems: 'center'
    },
    mobileSubmenu: (expanded) => ({
      maxHeight: expanded ? '600px' : '0',
      overflow: 'hidden',
      transition: 'max-height 0.3s ease-in-out'
    }),
    mobileSubmenuItem: {
      backgroundColor: '#f8fafc'
    },
    mobileSubmenuLink: {
      display: 'flex',
      alignItems: 'center',
      padding: '0.75rem 1rem 0.75rem 2.5rem',
      color: '#343a40',
      textDecoration: 'none',
      fontSize: '0.9rem',
      transition: 'all 0.3s ease-in-out'
    },
    sidebarOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1001,
      transition: 'opacity 0.3s ease-in-out, visibility 0.3s ease-in-out'
    }
  };

  // Media query styles
  const mediaStyles = {
    mobile: window.innerWidth <= 991.98,
    tablet: window.innerWidth <= 767.98,
    smallMobile: window.innerWidth <= 575.98
  };

  // Apply responsive styles
  if (mediaStyles.mobile) {
    styles.desktopNav.display = 'none';
    styles.mobileToggleBtn.display = 'flex';
  }

  if (mediaStyles.tablet) {
    styles.logo.height = '50px';
    styles.modernDropdown.minWidth = '95vw';
    styles.modernDropdown.maxWidth = '95vw';
    styles.modernDropdown.left = '2.5vw';
    styles.modernDropdown.transform = 'none';
    styles.megamenuContainer.flexDirection = 'column';
    styles.categoriesSidebar.width = '100%';
    styles.categoriesSidebar.borderRight = 'none';
    styles.categoriesSidebar.borderBottom = '1px solid #e5e7eb';
    styles.coursesContent.width = '100%';
    styles.coursesGrid.gridTemplateColumns = 'repeat(2, 1fr)';
  }

  if (mediaStyles.smallMobile) {
    styles.logo.height = '45px';
    styles.coursesGrid.gridTemplateColumns = '1fr';
  }
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.dropdown-container') && !event.target.closest('.dropdown-trigger')) {
        setIsOpen(false);
      }
    };

    // Close dropdown when viewport size changes to mobile
    const handleResize = () => {
      if (window.innerWidth < 992 && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('resize', handleResize);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, [isOpen]);

  // Mobile menu accordion functionality
  const [expandedItems, setExpandedItems] = useState({});
  
  const toggleMobileSubmenu = (categoryId) => {
    setExpandedItems(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  // Categories and Courses Data
  const programCategories = [
    {
      id: 'competitive-exams',
      title: 'Competitive Exams',
      description: 'UPSC, SSC, DRDO, PSUs, IIT-JEE, NEET, ESE, GATE, AE/JE, Olympiad',
      icon: <FaGraduationCap />,
      courses: [
        {
          id:'upsc',
          title: 'UPSC - Board',
          icon: <FaUniversity style={{color:'#1bc20fff'}} />,
          path: '/upsc',

        },

        {
          id: 'iitjee-mains',
          title: 'IIT JEE Mains',
          icon: <FaSchool style={{ color: '#3b82f6' }} />,
          path: '/iit_jee/mains',
        },
        {
          id: 'iitjee-advanced',
          title: 'IIT JEE Advanced',
          icon: <FaBuilding style={{ color: '#8b5cf6' }} />,
          path: '/iit_jee/advanced',
        },
        {
          id: 'neet-ug',
          title: 'NEET UG',
          icon: <FaFlask style={{ color: '#10b981' }} />,
          path: '/neet/ug',
        },
        {
          id: 'combo-jee-neet',
          title: 'JEE + NEET Combo',
          icon: <FaGraduationCap style={{ color: '#f59e0b' }} />,
          path: '/combo/jee-neet',
        },

        {
          id: 'olympiad',
          title: 'Science Olympiad',
          icon: <FaGlobe style={{ color: '#eab308' }} />,
          path: '/olympiad',
        },

        {
          id: 'gate',
          title: 'GATE',
          icon: <FaUniversity style={{ color: '#ef4444' }} />,
          path: '/gate',
        },
      ]
    },
    {
      id: 'software-courses',
      title: 'Software Programs',
      description: 'Development, Design, AI/ML, Data Science',
      icon: <FaLaptopCode />,
      courses: [
        {
          id: 'web-development',
          title: 'Web Development',
          icon: <FaLaptopCode style={{ color: '#3b82f6' }} />,
          path: '/web-development',
        },
        {
          id: 'app-dev',
          title: 'App Development',
          icon: <FaLaptopCode style={{ color: '#10b981' }} />,
          path: '/app-development',
        },

        {
          id: 'data-science',
          title: 'Data Science',
          icon: <FaChartLine style={{ color: '#8b5cf6' }} />,
          path: '/data-science',
        },

        {
          id: 'ai-ml',
          title: 'AI & Machine Learning',
          icon: <FaLaptopCode style={{ color: '#ef4444' }} />,
          path: '/ai-ml',
        },

        {
          id: 'cloud-computing',
          title: 'Cloud Computing',
          icon: <FaLaptopCode style={{ color: '#06b6d4' }} />,
          path: '/cloud-computing',
        },

      ]
    },
    {
      id: 'earth-sciences',
      title: 'Earth Sciences',
      description: 'Geology, Geophysics, Environment, Climatology',
      icon: <FaOilCan />,
      courses: [
        {
          id: 'geology',
          title: 'Geology',
          icon: <FaOilCan />,
          path: '/earth-sciences/geology',
        },
        {
          id: 'geophysics',
          title: 'Geophysics',
          icon: <FaOilCan />,
          path: '/earth-sciences/geophysics',
        },
        {
          id: 'environmental-sci',
          title: 'Environmental Science',
          icon: <FaFlask />,
          path: '/earth-sciences/environmental',
        },
        {
          id: 'climatology',
          title: 'Climatology',
          icon: <FaGlobe />,
          path: '/earth-sciences/climatology',
        },
      ]
    },
    {
      id: 'government-exams',
      title: 'Government Exams',
      description: 'UPSC, SSC, Banking, Defence, Railways',
      icon: <FaUniversity />,
      courses: [
        {
          id: 'upsc',
          title: 'UPSC',
          icon: <FaUniversity />,
          path: '/government/upsc',
        },
        {
          id: 'ssc',
          title: 'SSC',
          icon: <FaBook />,
          path: '/government/ssc',
        },
        {
          id: 'banking',
          title: 'Banking Exams',
          icon: <FaChartLine />,
          path: '/government/banking',
        },
        {
          id: 'defence',
          title: 'Defence Exams',
          icon: <FaUniversity />,
          path: '/government/defence',
        },
        {
          id: 'railways',
          title: 'Railway Exams',
          icon: <FaUniversity />,
          path: '/government/railways',
        },
      ]
    },
    {
      id: 'pg-entrance',
      title: 'PG Entrance Exams',
      description: 'GATE, IIT JAM, UGC NET, NEET PG, CSIR NET',
      icon: <FaUserGraduate />,
      courses: [
        {
          id: 'gate-exam',
          title: 'GATE',
          icon: <FaUserGraduate />,
          path: '/pg-entrance/gate',
        },
        {
          id: 'iit-jam',
          title: 'IIT JAM',
          icon: <FaUserGraduate />,
          path: '/pg-entrance/iit-jam',
        },
        {
          id: 'ugc-net',
          title: 'UGC NET',
          icon: <FaUserGraduate />,
          path: '/pg-entrance/ugc-net',
        },
        {
          id: 'neet-pg',
          title: 'NEET PG',
          icon: <FaFlask />,
          path: '/pg-entrance/neet-pg',
        },
        {
          id: 'csir-net',
          title: 'CSIR NET',
          icon: <FaUserGraduate />,
          path: '/pg-entrance/csir-net',
        },
      ]
    },
    {
      id: 'industry-placements',
      title: 'Industry Placements',
      description: 'ONGC, PARC, AMD, MNCs, Startups',
      icon: <FaChartLine />,
      courses: [
        {
          id: 'ongc-training',
          title: 'ONGC Placement Training',
          icon: <FaOilCan style={{ color: '#3b82f6' }} />,
          path: '/placements/ongc',
        },
        {
          id: 'parc-amd',
          title: 'BARC & AMD Preparation',
          icon: <FaFlask style={{ color: '#10b981' }} />,
          path: '/placements/barc-amd',
        },
        {
          id: 'mnc-interview',
          title: 'MNC Interview Preparation',
          icon: <FaChartLine style={{ color: '#8b5cf6' }} />,
          path: '/placements/mnc',
        },
        {
          id: 'startup-bootcamp',
          title: 'Startup Bootcamps with founders',
          icon: <FaLaptopCode style={{ color: '#f59e0b' }} />,
          path: '/placements/startup',
        },
      ]
    },
    {
      id: 'international-exams',
      title: 'International Exams',
      description: 'GRE, GMAT, TOEFL, IELTS, SAT, FMGE, PTE, Duolingo',
      icon: <FaGlobe />,
      courses: [
        {
          id: 'gre',
          title: 'GRE',
          icon: <FaGlobe style={{ color: '#ef4444' }} />,
          path: '/international/gre',
        },
        {
          id: 'gmat',
          title: 'GMAT',
          icon: <FaGlobe style={{ color: '#3b82f6' }} />,
          path: '/international/gmat',
        },
        {
          id: 'toefl',
          title: 'TOEFL',
          icon: <FaBook style={{ color: '#10b981' }} />,
          path: '/international/toefl',
        },
        {
          id: 'ielts',
          title: 'IELTS',
          icon: <FaBook style={{ color: '#8b5cf6' }} />,
          path: '/international/ielts',
        },
        {
          id: 'sat',
          title: 'SAT',
          icon: <FaGlobe style={{ color: '#f59e0b' }} />,
          path: '/international/sat',
        },
      ]
    },
     {
      id: 'Interships',
      title: 'Real Company Internships',
      description: 'Quantum, Space Tech, AI&ML, GenAI & LLM, Cloud Computing, Blockchain, AgriTech and More',
      icon: <FaMoneyBillAlt />,
      courses: [
        {
          id: 'Paid Internships',
          title: 'Paid Internships',
          icon: <FaMoneyCheckAlt style={{ color: '#008542ff', }} />,
          path: '/paid_internships',
        },
        {
          id: 'Internships',
          title: 'Non-Paid',
          icon: <FaMoneyCheck style={{ color: '#3b82f6' }} />,
          path: '/internship',
        },
        
      
      ]
    },
  ];

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
    if (!isOpen) {
      setActiveCategory(programCategories[0].id);
    }
  };

  const handleCategoryMouseEnter = (categoryId) => {
    setActiveCategory(categoryId);
  };

  // Navigation function
  const handleNavigation = (path) => {
    setIsOpen(false);
    setShowOffcanvas(false);
    navigate(path);
  };

  return (
    <>
      <header style={styles.navbarCustom}>
        <div style={styles.navbarContainer}>
          
          {/* Brand Logo */}
          <Link to="/" style={styles.navbarBrand} onClick={() => handleNavigation('/')}>
            <img src={logo} alt="Logo" style={styles.logo} /> 
          </Link>

          {/* Desktop Navigation */}
          <nav style={styles.desktopNav}>
            <ul style={styles.navList}>
              <li style={styles.navItem}>
                <Link 
                  to="/" 
                  style={styles.navLink} 
                  onClick={() => handleNavigation('/')}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#ffffffff'}
                >
                  <FaHome style={styles.navIcon} /> <span className='fw-bold'  >Home</span>
                </Link>
              </li>
              
              {/* All Courses Dropdown */}
              <li style={styles.navItem} className="dropdown-container">
                <button 
                  style={styles.dropdownTrigger} 
                  className="dropdown-trigger"
                  onClick={toggleDropdown}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#343a40'}
                >
                  <span className='bg-primary fw-bold text-white  text-decoration-underline p-3 border-3 rounded-3'>All Courses</span>
                </button>
                
                {isOpen && (
                  <motion.div 
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.2 }}
                    style={styles.modernDropdown}
                  >
                    <div style={styles.megamenuContainer}>
                      {/* Left Side - Categories */}
                      <div style={styles.categoriesSidebar}>
                        {programCategories.map((category) => (
                          <div 
                            key={category.id}
                            style={{
                              ...styles.categoryItem,
                              ...(activeCategory === category.id ? styles.categoryItemActive : {})
                            }}
                            onMouseEnter={() => handleCategoryMouseEnter(category.id)}
                          >
                            <div style={styles.categoryIcon}>{category.icon}</div>
                            <div style={styles.categoryInfo}>
                              <div style={styles.categoryTitle}>{category.title}</div>
                              <div style={styles.categoryDesc}>{category.description}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                      
                      {/* Right Side - Courses */}
                      <div style={styles.coursesContent}>
                        <h5 style={styles.coursesHeader}>
                          {programCategories.find(cat => cat.id === activeCategory)?.title} Courses
                        </h5>
                        <div style={styles.coursesGrid}>
                          {programCategories.find(cat => cat.id === activeCategory)?.courses.map((course) => (
                            <div
                              key={course.id}
                              style={styles.courseCard}
                              onClick={() => handleNavigation(course.path)}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.transform = 'translateY(-5px)';
                                e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.12)';
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = '#f8f9fa';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.1)';
                              }}
                            >
                              <div style={styles.courseIcon}>{course.icon}</div>
                              <div style={styles.courseTitle}>{course.title}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </li>
                 <li style={styles.navItem}>
                <Link 
                  to="/competitive-exams" 
                  style={styles.navLink} 
                  onClick={() => handleNavigation('/competitive-exams')}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#343a40'}
                >
                                  
                  <span className=' fw-bold text-white  p-3 rounded-3 border-3' >  <FaGraduationCap style={styles.navIcon} /> Competitive Exams</span>

                </Link>
              </li>
              {/* <li style={styles.navItem}>
                <Link 
                  to="/neet" 
                  style={styles.navLink} 
                  onClick={() => handleNavigation('/neet')}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#343a40'}
                >
                  <FaBookMedical style={styles.navIcon} /> <span>NEET</span>
                </Link>
              </li>
              
              <li style={styles.navItem}>
                <Link 
                  to="/iit_jee" 
                  style={styles.navLink} 
                  onClick={() => handleNavigation('/iit_jee')}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#343a40'}
                >
                  <FaSchool style={styles.navIcon} /> <span>IIT - JEE</span>
                </Link>
              </li> */}
                        <li style={styles.navItem}>
                <Link 
                  to="/job-oriented-programs" 
                  style={styles.navLink} 
                  onClick={() => handleNavigation('/job-oriented-programs')}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#343a40'}
                >
                 <span className=' fw-bold text-white  p-3 rounded-3 border-3' >Job Oriented Courses</span>
                </Link>
              </li>
              <li style={styles.navItem}>
                <Link 
                  to="/ai_resumepage" 
                  style={styles.navLink} 
                  onClick={() => handleNavigation('/ai_resumepage')}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#343a40'}
                >
                   <span className=' fw-bold text-white
                  text-decoration-underline p-3 border-3 rounded-3'> <FaRobot style={styles.navIcon} /> AI Resume</span>
                </Link>
              </li> 
              <li style={styles.navItem}>
                <Link 
                  to="/paid_internships" 
                  style={styles.navLink} 
                  onClick={() => handleNavigation('/internship')}
                  onMouseEnter={(e) => e.target.style.color = '#58A950'}
                  onMouseLeave={(e) => e.target.style.color = '#343a40'}
                >
                  <span className=' bg-success fw-bold text-white 
                  text-decoration-none p-3 border-3 rounded-3' >  
                  <FaMoneyBillWave style={styles.navIcon} />
                  Paid Internships
                  </span>
                </Link>
              </li>
              
                {/* <li style={styles.navItem}>
                  <button 
                  style={styles.dropdownTrigger} 
                > <a className='bg-black fw-bold text-white text-decoration-none p-3 border-3 rounded-3' href='/ai-vision-studio'> 
                <span >                  <FaRockrms className="text-warning" size={25} />
                </span> EdVision Studio</a>
                </button>
              </li> */}
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <button style={styles.mobileToggleBtn} onClick={() => setShowOffcanvas(true)}>
            <FaBars className="bg-white" />
          </button>
        </div>
      </header>

      {/* Mobile Sidebar Menu */}
      <div style={styles.mobileSidebar}>
        <div style={styles.sidebarHeader}>
          <h3   style={styles.sidebarHeaderH3}>Menu</h3>
          <button style={styles.closeBtn} onClick={() => setShowOffcanvas(false)}>
            <FaTimes  />
          </button>
        </div>
        
        <nav>
          <ul style={styles.mobileNavList}>
            <li style={styles.mobileNavItem}>
              <Link 
                to="/" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaHome style={styles.navIcon} /> Home
              </Link>
            </li>
            
            {/* Mobile Courses Accordions */}
            {programCategories.map((category) => (
              <li key={category.id} style={styles.mobileNavItem}>
                <div 
                  style={{...styles.mobileNavLink, ...styles.mobileDropdownToggle}}
                  onClick={() => toggleMobileSubmenu(category.id)}
                >
                  <span>{category.icon} {category.title}</span>
                  <span style={{ fontSize: '1.2rem', transition: 'transform 0.3s ease' }}>
                    {expandedItems[category.id] ? '−' : '+'}
                  </span>
                </div>
                
                <div style={styles.mobileSubmenu(expandedItems[category.id])}>
                  {category.courses.map((course) => (
                    <div key={course.id} style={styles.mobileSubmenuItem}>
                      <Link 
                        to={course.path} 
                        style={styles.mobileSubmenuLink}
                        onClick={() => handleNavigation(course.path)}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#f1f5f9';
                          e.target.style.color = '#58A950';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                          e.target.style.color = '#343a40';
                        }}
                      >
                        {course.icon} {course.title}
                      </Link>
                    </div>
                  ))}
                </div>
              </li>
            ))}
            
            <li style={styles.mobileNavItem}>
              <Link 
                to="/catalogue" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/catalogue')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaBook style={styles.navIcon} /> Catalogue
              </Link>
            </li>
            
            <li style={styles.mobileNavItem}>
              <Link 
                to="/neet" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/neet')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaBookMedical style={styles.navIcon} /> NEET
              </Link>
            </li>
            
            <li style={styles.mobileNavItem}>
              <Link 
                to="/iit_jee" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/iit_jee')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaSchool style={styles.navIcon} /> IIT - JEE
              </Link>
            </li>

            <li style={styles.mobileNavItem}>
              <Link 
                to="/calculator" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/calculator')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaCalculator style={styles.navIcon} /> Calculators
              </Link>
            </li>

            <li style={styles.mobileNavItem}>
              <Link 
                to="/ai_resumepage" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/ai_resumepage')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaListAlt style={styles.navIcon} /> AI Resume
              </Link>
            </li>
            
            <li style={styles.mobileNavItem}>
              <Link 
                to="/interviewer_page" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/interviewer_page')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaRobot style={styles.navIcon} /> AI Interviewer
              </Link>
            </li>
            
            <li style={styles.mobileNavItem}>
              <Link 
                to="/careers" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/careers')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaBuilding style={styles.navIcon} /> Careers
              </Link>
            </li>
            
            <li style={styles.mobileNavItem}>
              <Link 
                to="/internship_form" 
                style={styles.mobileNavLink} 
                onClick={() => handleNavigation('/internship_form')}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f1f5f9';
                  e.target.style.color = '#58A950';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent';
                  e.target.style.color = '#343a40';
                }}
              >
                <FaProjectDiagram style={styles.navIcon} /> Internship Form
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      {/* Overlay for when mobile sidebar is open */}
      {showOffcanvas && (
        <div style={styles.sidebarOverlay} onClick={() => setShowOffcanvas(false)}></div>
      )}
    </>
  );
};

export default MyNavbar;
